// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'automation-call';

export const Component = () => (
  <path
    fill='currentColor'
    d='m6.896 17.734-.67.718L0 12.322 6.226 6l.719.67-5.556 5.652 5.508 5.412zm17.529-5.604-6.226 6.322-.719-.718 5.556-5.603-5.508-5.46.67-.671 6.226 6.13zM15.15 6.5l-1.94 4.061h3.824L9.757 19.75l.816-5.876H7.237l3.21-7.374zm-6.387 6.374h2.96l-.47 3.375 3.714-4.688h-3.342L13.563 7.5h-2.461z'
  />
);

export const viewBox = '0 0 25 25';
